import WhatsappIcon from "../icon/whatsapp.png";

function WhatsapIcon() {
  const phoneNumber = "+23409060002731"; // replace with your number
  const message = "Hello! I'm interested in your services.";

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };
  return (
    <>
      <img
        className="whatsapp-button"
        title="Chat us"
        src={WhatsappIcon}
        alt="whatsapp"
        style={{
          width: "60px",
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: "1000",
          cursor: "pointer",
        }}
        onClick={handleClick}
      />
    </>
  );
}

export default WhatsapIcon;
